import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store } from '../App';
import { signin } from '../Service/LoginService';
import { getAllQuestions } from '../Service/QuestionService';
import { loadPopup } from '../Utils/LoginUtils';
import { CircularProgress } from '@mui/material';
import CameraMicTest from './CameraMicTest';


export const HomeComponent = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [progress, setProgress] = useState(false);

    const { setData,isCameraActivestore,isMicActivestore } = useContext(Store);

    const navigate = useNavigate();

    const isEmailValid = () => {
        return (email && email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g));
    }
    const isPasswordValid = () => {
        return (password && password.trim().length == 6);
    }


    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setError('');
    }
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setError('');
    }

    const onSubmit = (e) => {
        e.preventDefault();
        // console.log(email + ", " + password)
        setButtonDisabled(true);

     
        setProgress(true);
        signin({ email, password }).then(
            response => {
                if (response.data === 'COMPLETED') {
                    loadPopup('Test already started or completed')
                    setProgress(false);
                    return;
                } else if (response.data === 'CANCELLED') {
                    loadPopup('Test cancelled')
                    setProgress(false);
                    return;
                } else if (response.data === 'EXPIRED') {
                    loadPopup('Test expired')
                    setProgress(false);
                    return;
                }
                if (response.data.token) {
                    setError("");
                    sessionStorage.setItem('candidateCreds', JSON.stringify(response.data.token));
                    getAllQuestions(email, password).then(
                        response => {
                            setData(response.data);
                            console.log(response.data);
                            setProgress(false);
                            navigate('/preTestTimer');
                        }
                    ).catch((err) => {
                        console.log("Error catched-Questions", err);
                        if (err.status === undefined)
                            loadPopup('Ugh! Server down, please contact HR');
                        else if (err.code === 'ERR_NETWORK' && err.response.status === null) {
                            loadPopup('Server down, please contact HR');
                        } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 401) {
                            loadPopup('Unauthorized!');
                        } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 403) {
                            loadPopup('Forbidden!');
                        } else if (err.code === 'ERR_BAD_RESPONSE' || err.response.status === 500) {
                            loadPopup('Ugh! Something went wrong.');
                        } else {
                            loadPopup(err.code + "-" + err.response.status);
                        }
                        setProgress(false);
                    });
                } else {
                    loadPopup('Email or security code is incorrect')
                    setProgress(false);
                }
            }
        ).catch((err) => {
            console.log("Error catched", err);
            if (err.status === undefined)
                loadPopup('Ugh! Server down, please contact HR');
            else if (err.code === 'ERR_NETWORK' && err.response.status === null) {
                loadPopup('Server down, please send an email at - hr@voicera-analytics.com');
            } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 401) {
                loadPopup('Unauthorized!');
            } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 403) {
                loadPopup('Forbidden!');
            } else if (err.code === 'ERR_BAD_RESPONSE' || err.response.status === 500) {
                loadPopup('Ugh! Something went wrong.');
            } else {
                loadPopup(err.code + "-" + err.response.status);
            }
            setProgress(false);
        });

           setTimeout(() => {
            setButtonDisabled(false);
        }, 10000);
    }

    const isFormValid = () => {
        return isEmailValid() && isPasswordValid() && isCameraActivestore && isMicActivestore;
      };

    return (
        <div className='mt-4' style={{ display: "flex", justifyContent: "space-around", marginBottom: "8rem" }}>
            <div style={{ width: "50%" }} className="text-muted p-2 mt-5 ms-5">
                <label className='p-2 border rounded' style={{ backgroundColor: "cadetblue", color: "antiquewhite" }}>Please go through below steps before you start the test.</label>
                <ul>
                    <li>Do not refresh the page, you might loose the test</li>
                    <li>Do not switch tabs/window between the test</li>
                    <li>Do not look here and there except the screen</li>
                    <li>Do not copy/paste any stuff</li>
                    <li>Candidate must be visible on camera</li>
                    <li>Keep your camera and mic turned on</li>
                </ul>
            </div>
      
            <form onSubmit={onSubmit} style={{ width: "40%" }}>
                <div className='p-5 m-2' style={{ display: "flex", justifyContent: "space-evenly", flexDirection: "column", height: "18rem" }}>

                    <div className='form-floating'>
                        <input className={
                            (email.trim().length === 0) ? "form-control mb-3" : isEmailValid() ? "form-control mb-3 is-valid" : "form-control mb-3 is-invalid"
                        } id="email" placeholder='Email address' autoComplete='off'
                            type="email" value={email} required onChange={handleEmailChange} />
                        <label htmlFor="email">Email address</label>
                    </div>
                    <div className='form-floating'>
                        <input className={
                            (password.trim().length === 0) ? "form-control mb-3" : isPasswordValid() ? "form-control mb-3 is-valid" : "form-control mb-3 is-invalid"
                        } id="password" autoComplete='on' placeholder='Password'
                            type="password" value={password} required onChange={handlePasswordChange} minLength='6' maxLength={6} />
                        <label htmlFor="password">Security Code</label>
                    </div>
                    <CameraMicTest/>
                    <button className='form-control btn border radius m-1' style={{ backgroundColor: "cadetblue", color: "antiquewhite" }}
                         disabled={!isFormValid() || buttonDisabled} >
                        {
                            !buttonDisabled && !progress
                                ? 'Login'
                                :
                                <div className='mt-1'>
                                    <CircularProgress
                                        color='inherit'
                                        size={18}
                                        thickness={5} />
                                </div>
                        }
                    </button>

                </div>
            </form>
            <div style={{ width: "10%" }}>
            </div>
        </div>
    )
}
